import tail from 'tail.select/js/tail.select-full.min';

export default class CustomSelect {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.select-tail:not(.page-select)'), el => {
			new CustomSelect(el);
		});
	}

	constructor(el) {
		const selectOptions = {
			search: el.classList.contains('select-tail--search'),
			descriptions: false,
			count: false,
			hideSelected: false,
			multiple: false,
			stayOpen: false,
			deselect: !!el.dataset.placeholder,
			placeholder: el.dataset.placeholder || '',
			animate: el.dataset.animate !== "false"
		}
		return tail(el, selectOptions);
	}
}
